<template>
  <div class="tw-relative tw-flex tw-flex-col tw-gap-2">
    <button
      class="tw-flex tw-cursor-pointer tw-justify-center tw-items-center tw-gap-3 tw-text-lg tw-bg-[#F1583D] tw-text-white tw-rounded-lg tw-py-4 tw-border-none tw-font-inter tw-font-semibold tw-w-full"
      @click="goToExportPage"
    >
      <span>Export</span>
      <i class="fa fa-external-link-alt" />
    </button>

    <button
      v-if="showOptimizationPackageExport"
      :disabled="isCapturing"
      class="tw-flex tw-cursor-pointer tw-justify-center tw-items-center tw-gap-3 tw-text-sm tw-bg-[#7959d5] tw-text-white tw-rounded-lg tw-py-3 tw-border-none tw-font-inter tw-font-semibold tw-w-full disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
      @click="exportOptimizationPackage"
    >
      <span v-if="isCapturing">
        <i class="fa fa-spinner fa-spin" />
        Preparing...
      </span>
      <span v-else>
        Export Optimization Package
        <i class="fa fa-file-archive tw-ml-1" />
      </span>
    </button>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import html2canvas from 'html2canvas';

export default {
  components: { },
  data() {
    return {
      isCapturing: false,
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
    showOptimizationPackageExport() {
      return (
        this.checkupStore.featureFlags.includes('Feature: Portfolio Checkup Optimization Tax') &&
        this.checkupStore.optimization?.optimizations?.length > 0
      );
    },
  },
  methods: {
    goToExportPage() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.checkupStore.setActiveArea('Export');
    },
    async exportOptimizationPackage() {
      this.isCapturing = true;
      try {
        const settingsEl = document.getElementById('optimizer-settings-content');
        if (settingsEl) {
          const hiddenAncestor = settingsEl.closest('.tw-hidden');
          if (hiddenAncestor) hiddenAncestor.classList.remove('tw-hidden');
          try {
            const canvas = await html2canvas(settingsEl, { scale: 1.5, useCORS: true });
            this.checkupStore.optimizerSettingsDataUrl = canvas.toDataURL('image/png');
          } finally {
            if (hiddenAncestor) hiddenAncestor.classList.add('tw-hidden');
          }
        }
        this.checkupStore.zipExportRequested = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.checkupStore.setActiveArea('Export');
      } catch (e) {
        console.error('Error starting optimization package export', e);
        this.checkupStore.zipExportRequested = false;
        this.checkupStore.optimizerSettingsDataUrl = null;
      } finally {
        this.isCapturing = false;
      }
    },
  },
};
</script>
